<template>
    <div>
        <BreadCrumb :data="breadCrumb" /> 
        <div class="multiItems">
            <b-card class="item primary">
                <div class="cardDesc">
                    <div class="cardTitle"> 
                        Ortalama Sinyal Sayısı (Günlük) 
                    </div>
                    <div class="cardDesc">
                        <span> 1528 </span>
                        <b-progress :value="1528" :max="5000" animated></b-progress>
                    </div>
                </div>
            </b-card>
            <b-card class="item danger">
                <div class="cardDesc">
                    <div class="cardTitle"> 
                        Ortalama Alarm Sayısı (Günlük) 
                    </div>
                    <div class="cardDesc">
                        <span> 561 </span>
                        <b-progress variant="danger" :value="561" :max="1000" animated></b-progress>
                    </div>
                </div>
            </b-card>
           <b-card class="item warning">
                <div class="cardDesc">
                    <div class="cardTitle"> 
                        Ortalama Sinyal İşleme Süresi 
                    </div>
                    <div class="cardDesc">
                        <span> 28 sn </span>
                        <b-progress variant="warning" :value="28" :max="100" animated></b-progress>
                    </div>
                </div>
            </b-card>
            <b-card class="item dark">
                <div class="cardDesc">
                    <div class="cardTitle"> 
                        Ortalama Arızalı Sinyal Sayısı
                    </div>
                    <div class="cardDesc">
                        <span> 411 </span>
                        <b-progress variant="dark" :value="411" :max="5000" animated></b-progress>
                    </div>
                </div>
            </b-card>
        </div>
        <div class="multiItems">
            <b-card class="item info">
                <div class="cardDesc">
                    <div class="cardTitle"> 
                        Teknik Servis Yönledirmesi
                    </div>
                    <div class="cardDesc">
                        <span> 12 </span>
                        <b-progress variant="info" :value="12" :max="100" animated></b-progress>
                    </div>
                </div>
            </b-card>
            <b-card class="item success">
                <div class="cardDesc">
                    <div class="cardTitle"> 
                        Gönderilen SMS sayısı 
                    </div>
                    <div class="cardDesc">
                        <span> 144 </span>
                        <b-progress variant="success" :value="144" :max="1000" animated></b-progress>
                    </div>
                </div>
            </b-card>
           <b-card class="item primary">
                <div class="cardDesc">
                    <div class="cardTitle"> 
                        Yapılan IVR araması 
                    </div>
                    <div class="cardDesc">
                        <span> 114 </span>
                        <b-progress variant="gray" :value="28" :max="100" animated></b-progress>
                    </div>
                </div>
            </b-card>
            <b-card class="item danger">
                <div class="cardDesc">
                    <div class="cardTitle"> 
                        Abone Şikayetleri
                    </div>
                    <div class="cardDesc">
                        <span> 3 </span>
                        <b-progress variant="danger" :value="3" :max="100" animated></b-progress>
                    </div>
                </div>
            </b-card>
        </div>
        <div class="multiItems">
            <b-card class="item">
                <Doughnut/>
            </b-card>
            <b-card class="item">
                <Progress/>
            </b-card>
            <b-card class="itemx2">
                <LineChart/>
            </b-card>
        </div>
         <div class="multiItems">
            <b-card class="item">
                <Operators/>
            </b-card>
            <b-card class="item">
                <OperatorCall/>
            </b-card>
        </div>
    </div>
</template>

<script>
    import LineChart from "./components/LineChart.vue"
    import Doughnut from "./components/Doughnut.vue"
    import Progress from "./components/Progress.vue"
    import Operators from "./components/Operators.vue"
    import OperatorCall from "./components/OperatorCall.vue"
    import BreadCrumb from '@/components/BreadCrumb'
    let breadCrumb = [
        { label: "Raporlar", url: "/Reports" },
        { label: "Genel Sistem Raporu", url: "/Reports/General" },
    ]

    export default {
        name: 'GeneralReports',
        
        data:function(){
            return{
              breadCrumb
            }
        },
        components:{
            BreadCrumb, LineChart, Doughnut, Progress, Operators, OperatorCall
        },
        methods:{
        }
    }
</script>

<style lang="css" scoped> 
    @import "./styles/report.min.css"; 
</style>


// WEBPACK FOOTER //
// src/pages/General/Reports/General.vue